import { resolveEvaluation } from "@/helpers/flipt";
import { EvaluationContext, Provider, ResolutionDetails, JsonValue } from "@openfeature/web-sdk";

export class LocalFeatureFlagProvider implements Provider {
  readonly metadata = {
    name: "localFeatureFlagProvider",
  };

  resolveBooleanEvaluation(flagKey: string, defaultValue: boolean, _context: EvaluationContext): ResolutionDetails<boolean> {
    return resolveEvaluation<boolean>(flagKey, defaultValue);
  }

  resolveStringEvaluation(flagKey: string, defaultValue: string, _context: EvaluationContext): ResolutionDetails<string> {
    return resolveEvaluation<string>(flagKey, defaultValue);
  }

  resolveNumberEvaluation(flagKey: string, defaultValue: number, _context: EvaluationContext): ResolutionDetails<number> {
    return resolveEvaluation<number>(flagKey, defaultValue);
  }

  resolveObjectEvaluation<T extends JsonValue>(flagKey: string, defaultValue: T, _context: EvaluationContext): ResolutionDetails<T> {
    return resolveEvaluation<T>(flagKey, defaultValue);
  }
}
